/**
 * Згода на статистику (GDPR, зміна onboarding-share-first).
 *
 * Вибір живе лише в цьому браузері. Якщо сховище недоступне (приватний режим,
 * заблоковані дані сайту), відповідь тримається в памʼяті до кінця сесії
 * сторінки: після перезавантаження банер покажеться знову, а статистика до
 * нової відповіді не завантажиться.
 */
export type Consent = 'granted' | 'denied';

const STORAGE_KEY = 'o2o_analytics_consent';

let memory: Consent | null = null;
const listeners = new Set<(consent: Consent | null) => void>();

function read(): Consent | null {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    if (value === 'granted' || value === 'denied') return value;
  } catch {
    // Сховище недоступне — далі памʼять.
  }
  return memory;
}

export function getConsent(): Consent | null {
  return read();
}

export function setConsent(consent: Consent): void {
  memory = consent;
  try {
    window.localStorage.setItem(STORAGE_KEY, consent);
  } catch {
    // Лише на цю сесію сторінки.
  }
  for (const listener of listeners) listener(consent);
}

export function onConsentChange(listener: (consent: Consent | null) => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** Лише для тестів: скинути памʼять між кейсами. */
export function resetConsentForTests(): void {
  memory = null;
  listeners.clear();
}
